
import { useState } from "react";
import { Slider } from "@/components/ui/slider";
import { AlertCircle } from "lucide-react";
import { Voucher } from "@/types/voucher";

interface RedemptionSliderProps {
  voucher: Voucher;
  isRedeeming: boolean;
  onRedeem: () => Promise<void>;
}

export function RedemptionSlider({ 
  voucher, 
  isRedeeming, 
  onRedeem 
}: RedemptionSliderProps) {
  const [sliderValue, setSliderValue] = useState([0]);

  const handleSliderChange = (value: number[]) => {
    setSliderValue(value);
    
    if (value[0] >= 90) {
      handleSlideComplete();
    }
  };

  const handleSlideComplete = async () => {
    if (sliderValue[0] < 90) {
      setSliderValue([0]);
      return;
    }
    
    await onRedeem();
    setSliderValue([0]);
  };

  if (voucher.isRedeemed) {
    return (
      <div className="bg-gray-900 p-4 rounded-md text-center">
        <p className="text-sm">
          This voucher was redeemed on{" "}
          {voucher.redeemedAt && new Date(voucher.redeemedAt).toLocaleDateString()}
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-2 pt-2">
      <div className="relative">
        <Slider
          value={sliderValue}
          onValueChange={handleSliderChange}
          max={100}
          step={1}
          disabled={isRedeeming}
          className="h-12"
        />
        <div 
          className="absolute top-0 left-0 h-12 w-full flex items-center justify-center pointer-events-none"
        >
          <span className="text-sm font-medium">
            {isRedeeming ? "Redeeming..." : "Slide to redeem"}
          </span>
        </div>
      </div>
      <p className="text-xs text-gray-500 text-center">
        <AlertCircle className="inline h-3 w-3 mr-1" />
        You must be at the venue location to redeem
      </p>
    </div>
  );
}
